import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
} from "baseui/modal";
import { useTranslation } from "react-i18next";
import { Block } from "baseui/block";
import { Input } from "baseui/input";

export const DeleteModal = ({ isOpen, onClose, onDeleteConfirm }) => {
  const [confirmDeleteText, setConfirmDeleteText] = useState("");
  const { t } = useTranslation("common");

  const handleConfirmClick = () => {
    if (confirmDeleteText === t("deleteModal.confirmText")) {
      onDeleteConfirm();
      onClose();
    } else {
    }
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <ModalHeader>{t("deleteModal.title")}</ModalHeader>
      <ModalBody>
        {t("deleteModal.warningMessage")}
        <Block margin="20px 0">
          <Input
            size="mini"
            value={confirmDeleteText}
            onChange={(e) => setConfirmDeleteText(e.target.value)}
            placeholder={t("deleteModal.confirmPlaceholder")}
          />
        </Block>
      </ModalBody>
      <ModalFooter>
        <ModalButton kind="tertiary" onClick={onClose}>
          {t("deleteModal.cancelButton")}
        </ModalButton>
        <ModalButton
          disabled={confirmDeleteText !== t("deleteModal.confirmText")}
          onClick={handleConfirmClick}
        >
          {t("deleteModal.confirmButton")}
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
};
